export const loadType = {
  FCL: "FCL",
  LCL: "LCL",
  AIR: "AIR",
  LTL: "LTL",
  FTL: "FTL",
};
